import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const IndianaUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Indiana University Bloomington"
      universityShortName="IU"
      slug="indiana-university"
      seoTitle="IU Study Rooms | Indiana University Wells Library Study Spaces"
      seoDescription="Find study rooms at IU Bloomington including Wells Library collaboration rooms. Learn booking policies and discover CSW as an online alternative."
      seoKeywords="IU study rooms, Indiana University library, Wells Library, Bloomington study spaces, Hoosier study rooms"
      canonicalUrl="/study-room/indiana-university/"
      heroDescription="Navigate IU's Wells Library with its West Tower collaboration rooms and East Tower quiet study."
      libraryWebsiteUrl="https://libraries.indiana.edu"
      libraryWebsiteName="IU Libraries"
      studySpaces={[
        {
          name: "Wells Library West Tower - Collaboration Rooms",
          features: "18 rooms (4-8 seats), on-demand same-day via kiosks. Whiteboard equipped.",
          feedback: "Great for group projects. Reserve up to 3 times/week, 2 hours each."
        },
        {
          name: "Wells Library - 3rd & 4th Floors",
          features: "18 study rooms, must book 24 hours ahead. Available 2 weeks in advance.",
          feedback: "Good for planned group sessions."
        },
        {
          name: "Wells Library East Tower",
          features: "Quiet study area, designated silent zone.",
          feedback: "Should remain silent. Some ignore rules - bring headphones."
        },
        {
          name: "East Tower - Upper Floors",
          features: "Individual study desks, quietest areas in the library.",
          feedback: "Best for focused solo work. Very quiet atmosphere."
        }
      ]}
      guideContent={
        <>
          <p>
            The Wells Library's West Tower contains 18 collaboration rooms (4-8 seats) that can be reserved on demand 
            for same-day use via kiosks or personal devices. Additional 18 study rooms on the 3rd and 4th floors must 
            be reserved at least 24 hours in advance.
          </p>
          <p className="mt-4">
            Students may reserve rooms three times per week for up to two hours per reservation, with bookings 
            accepted two weeks ahead. The East Tower's quiet study area should remain silent.
          </p>
          <p className="mt-4">
            For group projects, book West Tower rooms via the on-demand kiosk; for solo work choose the higher floors 
            of the East Tower. If you need to brainstorm, portable whiteboards are available. 
            Respect the quiet zones to maintain harmony.
          </p>
        </>
      }
      summaryTips={[
        "West Tower has on-demand same-day reservations",
        "3rd/4th floor rooms need 24-hour advance booking",
        "Max 3 reservations per week, 2 hours each",
        "East Tower is designated quiet - respect it",
        "Portable whiteboards available for brainstorming"
      ]}
    />
  );
};

export default IndianaUniversity;
